<template>
          <div ref="searchBar">
              <div :class="['search-bar', {'tour-type-hide': !showTourTypeFilterForHotels}, {'tour-from-hide': !showHotelsFromFilter}, {'tour-type-and-tour-from-hide': !showTourTypeFilterForHotels && !showHotelsFromFilter}, {'tour-easy-search-mode': easySearchFilterForHotels}, {'common-filters-search-mode': getWindowSettings.commonFiltersForHotels}]">
                  <auto-complete v-if="showHotelsFromFilter"
                                  :placeholder="localizeList.departFrom"
                                  :items1="fligths"
                                  :items2="allCities"
                                  @focus="scrollToFilter()"
                                  @blur="filterBlur('from')"
                                  multiply
                                  v-model="searchTour.from"
                                  class="search-bar-item"/>

                  <auto-complete v-if="!easySearchFilterForHotels"
                                  :placeholder="localizeList.departTo"
                                  :items2="allCountryTo"
                                  :second-items="allCitiesTo"
                                  :focus-from-parent="focusFilterTo"
                                  @blur="filterBlur('to')"
                                  @focus="focusFilter('to')"
                                  @click="validation('departureTo')"
                                  @valid="tourToIsValid = $event"
                                  @get-cities="getCitiesToWithCash($event)"
                                  :show-cities="getSettings.IsShowFiltersByCity"
                                  second
                                  multiply
                                  v-model="searchTour.to"
                                  class="search-bar-item"/>
                  <auto-complet-combo v-else
                                      :placeholder="localizeList.resortOrHotelName"
                                      :items="comboItems"
                                      :all-items="comboAllItems"
                                      :disabled="!searchTour.from.length"
                                      :focus-from-parent="focusFilterTo"
                                      :loading="comboItemsLoading"
                                      @blur="filterBlur('to')"
                                      @focus="scrollToFilter('to')"
                                      @click="validation('departureTo')"
                                      @search="searchCombo"
                                      v-model="searchTour.combo"
                                      class="search-bar-item"/>

                  <auto-complet-tour-type v-show="showTourTypeFilterForHotels"
                                          :placeholder="localizeList.tourType"
                                          :items="tourTypeItems"
                                          :itemsChanged="tourTypeItemsChange"
                                          :disabled="tourTypeDisabled"
                                          :focus-from-parent="focusFilterTourType"
                                          @focus="scrollToFilter()"
                                          @blur="filterBlur('tourType')"
                                          @click="validation('tourType')"
                                          v-model="searchTour.tourType"
                                          class="search-bar-item"/>

                  <calendar :placeholder="localizeList.whenUpper"
                            v-model="date"
                            @change="getMinMaxDays($event)"
                            @click="validation('tourCalendar')"
                            @reload="reloadDate()"
                            @focus="scrollToFilter()"
                            @press-tab="focusPeopleCounter()"
                            @change-days="changeDays($event)"
                            @blur="filterBlur('date')"
                            @select-close="filterBlur($event)"
                            :focus-from-parent="focusFilterDate"
                            :day-mode="getSettings.TourSearchMode"
                            :disabled="disabledCalendar()"
                            :days-count="daysCount"
                            :max-dates="getSettings.MaxSearchDatesCountClient"
                            :max-duration="getSettings.MaxDurationsCountClient"
                            :active-dates="activeDates"
                            class="search-bar-item"/>

                  <people-counter :items="peopleCount"
                                  :show="peopleShow"
                                  @hide="peopleShow = false"
                                  @focus="scrollToFilter()"
                                  @tab="peopleTab = true"
                                  v-model="tourPeople"
                                  class="search-bar-item"/>
                  <base-button @click.native="search('tour', true)"
                                ref="searchButton"
                                :background="!peopleTab ? 'var(--orange-color)' : '#db6612'"
                                padding="4px 24px"
                                :searchLoaderStatus="searchLoaderStatus"
                                v-if="!getWindowSettings.commonFiltersForHotels">
                      <svg v-if="!searchLoaderStatus" width="24px" height="24px" fill="var(--white-color)">
                          <use xlink:href="../../assets/images/sprite.svg#search"></use>
                      </svg>
                      <base-loader v-else size="22" weight="5"/>
                  </base-button>
                  <input type="text" class="search-btn-helper"/>
              </div>

              <!--Компонента для показа валидации филтров-->
              <validation-popup :text="validationText" v-model="validationShow"/>
          </div>
</template>

<script>
    import * as methods from "@/plugins/methods.js"

    import {bus} from '../../main.js'

    import moment from "moment"
    import Vue from 'vue'

    import * as mTypesHotels from "@/stores/modules/hotels/mutation_types"

    import autoComplete from "./mainFilters/autoComplet";
    import calendar from "./mainFilters/calendar";
    import peopleCounter from "./mainFilters/peopleCounter";
    import validationPopup from "../baseComponents/validationPopup";
    import autoCompletTourType from "./mainFilters/autoCompletTourType";
    import autoCompletCombo from "./mainFilters/autoCompletCombo";

    export default {
        name: "hotelsMainFilter",
        components: {
            autoComplete,
            calendar,
            peopleCounter,
            validationPopup,
            autoCompletTourType,
            autoCompletCombo,
        },
        data() {
            return {
                API_URL: this.$store.getters['getApiUrl'],
                API_ORIGIN: this.$store.getters['getApiOrigin'],
                date: {},
                searchTour: {
                    from: ['-1'],
                    to: "",
                    combo: {},
                    tourType: [],
                },
                tourTypeItems: {
                    title: "Все варианты",
                    items: []
                },
                tourTypeItemsChange: 0,
                searchFlights: {
                    from: "",
                    to: "",
                },
                fligths: {
                    title: "",
                    items: []
                },
                allCities: {
                    title: "Все варианты",
                    items: []
                },
                allCountryTo: {
                    title: "Все варианты",
                    items: []
                },
                comboAllItems: [],
                comboItems: [],
                allCitiesTo: [],
                daysCount: [],
                daysCountCash: [],
                currentCurrency: "",
                rate: "",
                localize: [],
                currentLocalize: "",
                peopleCount: [
                    {
                        name: "adults",
                        count: 2
                    },
                    {
                        name: "childs",
                        count: 0
                    }
                ],
                tourPeople: {
                    adult: {},
                    children: []
                },
                activeDates: [],
                pagination: {
                    page: 1,
                    perPage: 20
                },
                cashComboSearchValue: "",
                validationShow: false,
                validationText: "",
                urlSearchStatus: true,
                peopleShow: false,
                peopleTab: false,
                tourCalendar: 0,
                direct: 1,
                cashUrl: "",
                mainSearchStatus: true,
                focusFilterTo: false,
                focusFilterTourType: false,
                focusFilterTourTypeReady: false,
                focusFilterDate: false,
                fixedFilters: false,
                isDarkTheme: false,
                countryOldApi: null,
                tourTypeOldApi: null,
                durationOldApi: null,
                searchComboTimeout: null,
                comboItemsLoading: false,
                changeSearchTourTo: false,
                cashTourUrl: "",
                cashTicketsUrl: "",
                cashQuotesUrl: "",
                cashHotelsUrl: "",
                settings: null,
            }
        },
        props: {
          tourType: {
            type: String,
            default: ""
          }
        },
        created() {
            bus.$on('main-search-hotels', () => {
                this.search("tour", true);
            });

            bus.$on('hotelsSearchNormal', () => {
              if (this.checkFiltersBeforeSearch) {
                this.search("tour", true);
              }
            });

            bus.$on("change-search-type", (type) => {
              if (type === "hotels") {
                this.getCities().then(() => {
                    let cashFrom = JSON.parse(methods.getCookieValueByName("hotelsTourFrom"));

                    if (cashFrom && !this.getWindowSettings.commonFiltersForHotels || this.getWindowSettings.commonFiltersForHotels && this.$route.params?.searchParams) {
                        this.searchTour.from = cashFrom
                    }

                    this.searchTourTo(['-1']);
                })
                .catch(() => {
                    // Обработка ошибки
                });
              }
            });

            bus.$on("mounted-hotels-search", () => {
                this.mounted();
            })
        },
        mounted() {
            this.settings = this.$store.getters['getSettings'];
            this.mounted();
        },
        computed: {
            getMainSearchCount() {
              return this.$store.getters['hotels/getMainSearchCount']
            },
            isBascket() {
                return this.$route.path.includes("Basket");
            },
            getFirstSearch() {
                return this.$store.getters['hotels/getFirstSearch'];
            },
            getCheckFilterSelect() {
                return this.$store.getters['hotels/getCheckFilterSelect'];
            },
            deviceFromSS(){
                // const isMobile = window.navigator.userAgentData.mobile;
                return sessionStorage.getItem('device') === 'desktop'
            },
            getSearchSecondParamsCounter() {
                return this.$store.getters['hotels/getSearchSecondParamsCounter'];
            },
            getWindowSettings() {
                return window.settings;
            },
            searchLoaderStatus() {
                return this.$store.getters['hotels/getSearchLoaderStatus']
            },
            showHotelsFromFilter() {
                return false
            },
            showTourTypeFilterForHotels() {
                return window.settings.showTourTypeFilterForHotels || window.settings.showTourTypeFilterForHotels === undefined
            },
            easySearchFilterForHotels() {
                return window.settings.easySearchFilterForHotels
            },
            tourTypeDisabled() {
                let res = false;
                if (
                    this.easySearchFilterForHotels && !this.searchTour.combo.countryKey ||
                    !this.easySearchFilterForHotels && this.searchTour.to.length < 1 ||
                    !this.easySearchFilterForHotels && this.searchTour.to.length < 2 && this.getSettings.IsShowFiltersByCity
                ) {
                    res = true
                }
                return res
            },
            getSettings() {
                return this.$store.getters['getSettings']
            },
            hasBasket() {
                return this.$route.fullPath.includes("Basket") || false
            },
            hasQuotes() {
                return this.$route.fullPath.includes("Individuals/Quotes") || false
            },
            hasHotels() {
                return this.$route.fullPath.includes("Individuals/Hotels") || false
            },
            checkFiltersBeforeSearch() {
                const from = this.searchTour.from.length > 0;
                const to = !this.easySearchFilterForHotels && this.searchTour.to.length >= 2 && this.getSettings.IsShowFiltersByCity;
                const easySearchFilterForHotels = this.easySearchFilterForHotels ? this.searchTour.combo.countryKey : this.searchTour.to.length > 0;
                const tourType = this.searchTour.tourType.length > 0;
                const date = this.date.dates?.length > 0;
                const invalidAge = this.tourPeople.children.some(child => child.age === null);

                return from && to && easySearchFilterForHotels && tourType && date && !invalidAge;
            }
        },
        methods: {
            replaceUrl() {
                // Проверяем на карректность урла
                if (
                    !location.href.includes("#/?") &&
                    (location.href.includes("/?") || (location.href.includes("?") && !this.isBascket))
                ) {
                    location.href = location.href
                        .replace(/#\/.+|#\//, "")
                        .replace("/?", "#/")
                        .replace("?", "#/");
                    return;
                }

                if (!this.$route.fullPath.includes("?") || this.isBascket) return;

                const newUrl = this.$route.fullPath.replace("?", "");
                if (!this.$route.path.includes(newUrl)) {
                    this.$router.push(newUrl);
                }
            },
            translit(text) {
                if (!text) return "";
                return this.$store.getters['translit'](text, 5)
            },
            cashComboSearchFunc() {
                this.searchComboFunc = methods.cachingDecorator(this.searchComboFunc);
            },
            searchCombo(e) {
                if (!e) {
                    this.comboItems = [];
                    return;
                }

                this.comboItems = this.searchComboFunc(e);
            },
            searchComboFunc(e) {
                const res = [];
                const text = e.toLowerCase().trim();
                const textIsLat = text.match(/[A-Za-z]/);
                const textTranslit = this.translit(text);

                let items = this.comboAllItems;
                if (this.cashComboSearchValue && e.slice(0, -1) === this.cashComboSearchValue && this.comboItems.length) {
                    items = this.comboItems
                }
                this.cashComboSearchValue = e;

                items.forEach(x => {
                    const item = {...x};

                    const mapResByText = res.map(x3 => x3.text);
                    const countryText = `<${this.localizeList.country}> ${item.countryName}`;
                    const cityText = item.cityName ? `<${this.localizeList.city}> ${item.cityName}, ${item.countryName}` : countryText;
                    const hotelText = `<${this.localizeList.hotel}> ${item.hotelName} (${item.cityName}, ${item.resortName ? item.resortName + ', ' : ''}${item.countryName})`;
                    const resortText = `<${this.localizeList.resort}> ${item.resortName}, ${item.countryName}`;

                    const includeCountry =
                        item.countryName?.toLowerCase()?.includes(text) ||
                        (item.countryName.match(/[A-Za-z]/) || textIsLat) &&
                        this.translit(item.countryName).toLowerCase().includes(textTranslit) && !mapResByText.includes(cityText);

                    const includeCity =
                        (item.cityName?.toLowerCase()?.includes(text) ||
                        (item.cityName.match(/[A-Za-z]/) || textIsLat) &&
                        this.translit(item.cityName).toLowerCase().includes(textTranslit)) && !mapResByText.includes(cityText);

                    const includeHotel =
                        (item.hotelName?.toLowerCase()?.includes(text) ||
                        (item.hotelName.match(/[A-Za-z]/) || textIsLat) &&
                        this.translit(item.hotelName).toLowerCase().includes(textTranslit)) && !mapResByText.includes(hotelText);

                    const includeResort =
                        (item.resortName?.toLowerCase()?.includes(text) ||
                        (item.resortName.match(/[A-Za-z]/) || textIsLat) &&
                        this.translit(item.resortName).toLowerCase().includes(textTranslit)) && !mapResByText.includes(resortText);

                    if (includeHotel) {
                        item.isHotel = true;
                        item.isResort = false;
                        item.isCity = false;
                        item.text = hotelText;

                        const includeItem = mapResByText.includes(item.text);
                        if (!includeItem) {
                            res.push({...item});
                        }
                    }
                    if (includeResort) {
                        item.isHotel = false;
                        item.isResort = true;
                        item.isCity = false;
                        item.text = resortText;

                        const includeItem = mapResByText.includes(item.text);
                        if (!includeItem) {
                            res.push({...item});
                        }
                    }
                    if (includeCity || includeCountry) {
                        item.isHotel = false;
                        item.isResort = false;
                        item.isCity = true;
                        item.text = cityText;

                        const includeItem = mapResByText.includes(item.text);
                        if (!includeItem) {
                            res.push({...item});
                        }
                    }
                });

                return res;
            },
            getArrСitiesOfResort(data, country, resorts) { 
                const targetCountry = data.find(x => x.Key === country);
                const arrСitiesOfResort = targetCountry.Data.filter(x => x.ResortKey === resorts)
                const arrKeysCitiesOfResort = Array.from(new Set(arrСitiesOfResort.map(x => x.CityKey)));
                return arrKeysCitiesOfResort
            },
            setAllCombo(data) {
                this.cashComboSearchValue = "";
                this.comboAllItems = [];
                this.searchComboFunc("", true);
                let cashTourToCombo = JSON.parse(decodeURIComponent(methods.getCookieValueByName("hotelsTourToCombo")));
                let countryKey;
                let cityKey;
                let hotels = [];
                let resorts = [];

                const searchParams = this.$route.params.searchParams;
                // let isCity = false;
                let isHotel = false;
                let isResort = false;
                if (searchParams) {
                    // isCity = searchParams.includes("comboSearchCity");
                    isHotel = searchParams.includes("comboSearchHotel");
                    isResort = searchParams.includes("comboSearchResort");
                    searchParams.split("&")
                        .forEach(x => {
                            if (x.includes("destination")) {
                                countryKey = +x.split("_")[1];
                            } else if (x.includes("cities")) {
                                cityKey = +x.split("=")[1];
                            } else if (x.includes("hotels") && isHotel) {
                                hotels = x.split("=")[1].split(",").map(x => +x);
                            } else if (x.includes("resorts") && isResort) {
                                resorts = x.split("=")[1].split(",").map(x => +x);
                            }
                        });

                    if (isHotel && !hotels.length) isHotel = false
                    if (isResort && !resorts.length) isResort = false

                    if (cashTourToCombo) {
                        cashTourToCombo = null
                    }
                }

                data.forEach(x => {
                    x.Data.forEach(x2 => {
                        const item = {
                            countryKey: x.Key,
                            cityKeysOfResorts: this.getArrСitiesOfResort(data, x.Key, x2.ResortKey),
                            cityKey: x2.CityKey,
                            hotelKey: x2.HotelKey,
                            resortKey: x2.ResortKey,
                            countryName: x.Name,
                            cityName: x2.CityName,
                            hotelName: x2.HotelName,
                            resortName: x2.ResortName,
                            isCity: false,
                            isHotel: false,
                            isResort: false,
                            text: ""
                        };


                        const includeItem = this.comboAllItems
                            .map(x3 => `${x3.countryKey}${x3.cityKey}${x3.hotelKey}${x3.resortKey}`)
                            .includes(`${item.countryKey}${item.cityKey}${item.hotelKey}${item.resortKey}`);

                        if (includeItem) return;

                        if (
                            !this.searchTour.combo.countryName &&
                            !cityKey &&
                            cashTourToCombo?.countryKey &&
                            cashTourToCombo.countryKey === item.countryKey &&
                            (isResort || isHotel || cashTourToCombo.cityKey === item.cityKey) &&
                            (isResort || isHotel && cashTourToCombo.hotelKey === item.hotelKey) &&
                            (isHotel || isResort && cashTourToCombo.resortKey === item.resortKey)
                        ) {
                          this.searchTour.combo = cashTourToCombo
                        } else if (
                            !this.searchTour.combo.countryName &&
                            countryKey === item.countryKey &&
                            (!cityKey || cityKey === item.cityKey ) &&
                            (
                                hotels.length && hotels.includes(item.hotelKey) ||
                                resorts.length && resorts.includes(item.resortKey) ||
                                !hotels.length && !resorts.length
                            )
                        ) {
                            const copyItem = {...item};

                            if (hotels.length) copyItem.isHotel = true;
                            else if (resorts.length) copyItem.isResort = true;
                            else copyItem.isCity = true;

                          this.searchTour.combo = copyItem
                        }
                        this.comboAllItems.push(item);
                    });

                  const isAllCity =
                        x.Key === countryKey && cityKey === -1 && !isResort && !isHotel ||
                        !cityKey &&
                        cashTourToCombo?.countryKey === x.Key && cashTourToCombo?.cityKey === -1 && !isResort && !isHotel ||
                        x.Key === countryKey && !cashTourToCombo && !cityKey && !isResort && !isHotel;

                    const cityAllItem = {
                        countryKey: x.Key,
                        cityKey: -1,
                        hotelKey: null,
                        resortKey: null,
                        countryName: x.Name,
                        cityName: "",
                        hotelName: "",
                        resortName: "",
                        isCity: isAllCity,
                        isHotel: false,
                        isResort: false,
                        text: ""
                    };
                    if (isAllCity) {
                      this.searchTour.combo = {...cityAllItem}
                    }

                    this.comboAllItems.push(cityAllItem)
                });

            },
            mounted() {
              if (this.isBascket || this.tourType !== "hotels") return

              this.setUrlParams();
              let searchHotelsRemSys = this.getSettings.SearchHotelsInRemoteSystems;
              if (searchHotelsRemSys === 0) {
                  this.$store.dispatch("hotels/A_SET_SEARCH_IN_OUT", true);
                  this.$emit("changeSearchInOutForHotels", true);
              } else {
                  this.$store.dispatch("hotels/A_SET_SEARCH_IN_OUT", false);
                  this.$emit("changeSearchInOutForHotels", false);
              }

              setTimeout(() => {
                  this.getCities().then(() => {
                      let cashFrom = JSON.parse(methods.getCookieValueByName("hotelsTourFrom"));

                      if (cashFrom && !this.getWindowSettings.commonFiltersForHotels || this.getWindowSettings.commonFiltersForHotels && this.$route.params?.searchParams) {
                          this.searchTour.from = cashFrom
                      }

                      this.searchTourTo(['-1']);
                  })
              }, 0);
              },
              setPeopleOfLocalStorage() {
                  let cashPeople = JSON.parse(methods.getCookieValueByName("hotelsTourPeople"));
                  if (cashPeople) {
                      this.tourPeople = cashPeople
                      this.peopleCount = [
                          cashPeople.adult,
                          {
                              name: "childs",
                              count: cashPeople.children.length
                          }
                      ]
                  }
              },
            keyDown(e) {
                if (e.keyCode === 13 && this.peopleTab) {
                    this.search("tour");
                    this.peopleTab = false
                }
                if (e.keyCode === 9 && this.peopleTab) {
                    this.peopleTab = false
                }
            },
            setUrlParams() {
                let urlParams = this.$route.params.searchParams;
                if (urlParams && !this.isBascket) {
                    urlParams = urlParams.split("&")
                    let tourFrom = [];
                    let tourTo = [];
                    let tourType = [];
                    let date = {
                        dates: [],
                        daysCount: {
                            from: null,
                            to: null,
                        }
                    };
                    let people = {
                        adult: {name: "adults", count: null},
                        children: []
                    };

                    urlParams.forEach(x => {
                        if (x.includes("departureCities")) {
                            tourFrom = x.split("=")[1].split(",").map(x2 => +x2)
                        } else if (x.includes("destination")) {
                            const countryKey = +x.split("_")[1];
                            tourTo.unshift(countryKey);
                        } else if (x.includes("destCities")) {
                            x.split("=")[1].split(",").forEach(x2 => {
                                tourTo.push(+x2);
                            })
                        } else if (x.includes("tourType")) {
                            x.split("=")[1].split(",").forEach(x2 => {
                                tourType.push(+x2)
                            })
                        } else if (x.includes("dates")) {
                            x.split("=")[1].split(",").forEach(x2 => {
                                date.dates.push(x2)
                            })
                        } else if (x.includes("durations")) {
                            let days = x.split("=")[1].split(",");
                            if (this.getSettings.TourSearchMode === 1 || this.getSettings.TourSearchMode === 2) {
                                date.daysCount.from = +days[0] - 1;
                                date.daysCount.to = +days[days.length - 1] - 1;
                            } else {
                                date.daysCount.from = +days[0]
                                date.daysCount.to = +days[days.length - 1]
                            }
                        } else if (x.includes("adultCount")) {
                            people.adult.count = +x.split("=")[1]
                        } else if (x.includes("childAges")) {
                            let ages = x.split("=")[1].split(",");
                            ages.forEach(x2 => {
                                people.children.push({
                                    name: "ageOfChild",
                                    css: {marginLeft: "20px"},
                                    age: x2
                                })
                            })
                        }
                    });

                    document.cookie = `hotelsTourFrom=${JSON.stringify(tourFrom)}; path=/`;
                    document.cookie = `hotelsTourTo=${JSON.stringify(tourTo)}; path=/`;
                    document.cookie = `hotelsTourType=${JSON.stringify(tourType)}; path=/`;
                    document.cookie = `hotelsTourDate=${JSON.stringify(date)}; path=/`;
                    document.cookie = `hotelsTourPeople=${JSON.stringify(people)}; path=/`;

                    this.setPeopleOfLocalStorage();
                }
            },
            focusFilter(elem) {
                if (elem === 'to') {
                    // this.getCountryTo('tour');
                    this.scrollToFilter()
                }
            },
            filterBlur(elem) {
                if (elem === 'from') {
                    if (
                        this.easySearchFilterForHotels && this.searchTour.from.length && !this.searchTour.combo.countryName ||
                        !this.easySearchFilterForHotels && this.searchTour.from.length && !this.searchTour.to.length
                    ) {
                        this.focusFilterTo = true
                    }
                }
                if (elem === 'to') {
                    this.focusFilterTo = false;
                    if (
                        this.showTourTypeFilterForHotels &&
                        (this.easySearchFilterForHotels && this.searchTour.combo.countryKey && !this.focusFilterTourTypeReady && !this.tourTypeDisabled ||
                        !this.easySearchFilterForHotels && this.searchTour.to?.length && !this.focusFilterTourTypeReady && !this.tourTypeDisabled)
                    ) {
                        if(!this.getWindowSettings.commonFiltersForHotels) this.focusFilterTourType = true;
                        this.focusFilterTourTypeReady = true;
                    }
                    if(this.getWindowSettings.commonFiltersForHotels) {
                      setTimeout(() => {
                        this.commonSearch()
                      }, 500);
                    }
                }
                if (elem === 'tourType') {
                    this.focusFilterTourType = false;
                    if (this.searchTour.tourType?.length && !this.date.dates?.length && !this.disabledCalendar() && !this.getWindowSettings.commonFiltersForHotels) {
                        this.focusFilterDate = true
                    }
                    if(this.getWindowSettings.commonFiltersForHotels) {
                      setTimeout(() => {
                        this.commonSearch()
                      }, 500);
                    }

                }
                if (elem === 'date') {
                    this.focusFilterDate = false;
                    if(this.getWindowSettings.commonFiltersForHotels) {
                      setTimeout(() => {
                        this.commonSearch()
                      }, 500);
                    }
                }

               if (elem === 'duration') {
                    if(this.getWindowSettings.commonFiltersForHotels) {
                      setTimeout(() => {
                        this.commonSearch()
                      }, 500);
                    }
                }
            },
            scrollToFilter() {
                if (!this.$store.getters['getSearched']) {
                    window.scrollTo({
                        top: this.$refs.searchBar.offsetTop,
                        behavior: "smooth"
                    })
                }
            },
            focusPeopleCounter() {
                this.peopleShow = true
            },
            reloadDate() {
                this.date = JSON.parse(methods.getCookieValueByName("hotelsTourDate"))
            },
            changeDays(e) {
                // Скрываем результаты поиска если продолжительность была изменена
                if (e.days[0] !== this.date.daysCount.from && this.getWindowSettings.commonFiltersForHotels
                || e.days[1] !== this.date.daysCount.to && this.getWindowSettings.commonFiltersForHotels) {
                 this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false)
                }

                const days = e.days;
                const show = e.showPicker;

                if (!show && this.tourType === 'hotels') this.searchFirstTime();

                const checkRouteSearchParams = this.$route.params?.searchParams; // Параметры роута заполнятся только после запроса и останутся после перезагрузки страницы

                if (!show && this.getWindowSettings.commonFiltersForHotels && checkRouteSearchParams && !this.$store.getters['hotels/getOnMountedChangeDaysFlag']){
                    this.$nextTick(() => {
                      this.search('tour', true)
                    })
                }

                if (this.date && this.date.daysCount) {
                    this.date.daysCount.from = days[0];
                    this.date.daysCount.to = days[1];
                }
            },
            getCities() {
                return new Promise((resolve, reject) => {
                    let date = new Date().getTime();
                    Vue.Api.Get(this.API_URL + 'departureCities?_=' + date)
                        .then(res => {
                            if (!res.data.length) {
                                reject();
                                return
                            }
                            let data = res.data;

                            this.fligths.items = [];
                            this.allCities.items = [];
                            data.forEach((val) => {
                                if (val.Key === -1) {
                                    this.fligths.items.push({
                                        text: val.Name,
                                        id: val.Key,
                                        isChecked: false
                                    })
                                } else {
                                    this.allCities.items.push({
                                        text: val.Name,
                                        id: val.Key,
                                        isChecked: false
                                    })
                                }

                            })
                            resolve(true)
                        });
                })
            },
            validation(type) {
                let text = this.localizeList.firstSetField;

                switch (type) {
                    case "departureTo":
                        if (!this.searchTour.from.length) {
                            text += " " + this.localizeList.fromUpper;
                            this.showValidation(text)
                        }
                        break;
                    case "tourType":
                        if (!this.searchTour.from.length) {
                            text += " " + this.localizeList.fromUpper
                            this.showValidation(text)
                            break;
                        }
                        if (
                            this.easySearchFilterForHotels && !this.searchTour.combo.countryKey ||
                            !this.easySearchFilterForHotels && this.searchTour.to.length < 1
                        ) {
                            text += " " + this.localizeList.departTo
                            this.showValidation(text);
                            break
                        }
                        if (!this.easySearchFilterForHotels && this.searchTour.to.length < 2 && this.getSettings.IsShowFiltersByCity) {
                            text += " " + this.localizeList.cityUpper
                            this.showValidation(text);
                            break
                        }
                        break;
                    case "tourCalendar":
                        if (!this.searchTour.from.length) {
                            text += " " + this.localizeList.fromUpper
                            this.showValidation(text)
                            break;
                        }
                        if (
                            this.easySearchFilterForHotels && !this.searchTour.combo.countryKey ||
                            !this.easySearchFilterForHotels && this.searchTour.to.length < 1
                        ) {
                            text += " " + this.localizeList.departTo
                            this.showValidation(text);
                            break
                        }
                        if (!this.easySearchFilterForHotels && this.searchTour.to.length < 2 && this.getSettings.IsShowFiltersByCity) {
                            text += " " + this.localizeList.cityUpper
                            this.showValidation(text);
                            break
                        }
                        if (!this.searchTour.tourType.length) {
                            text += " " + this.localizeList.tourType
                            this.showValidation(text)
                            break
                        }
                        break;
                }
            },
            disabledCalendar() {
                return (
                    this.easySearchFilterForHotels && !this.searchTour.combo.countryKey ||
                    !this.easySearchFilterForHotels && this.searchTour.to.length < 2 && this.getSettings.IsShowFiltersByCity ||
                    !this.easySearchFilterForHotels && this.searchTour.to.length < 1 && !this.getSettings.IsShowFiltersByCity
                )
            },
            showValidation(text) {
                this.validationShow = true;
                this.validationText = text;
            },
            getCountryTo() {
                let cities = "";

                cities = this.searchTour.from.map(x => `departureCities=${x}`)

                let apiUrl = this.API_URL + 'Destination?' + cities.join("&");
                if (this.easySearchFilterForHotels) {
                    apiUrl += "&type=1"
                }

                Vue.Api.Get(apiUrl)
                    .then(res => {
                        if (this.easySearchFilterForHotels) {
                            this.setAllCombo(res.data);
                        }
                        this.allCountryTo.items = [];
                        let data = res.data;
                        let isCash = false;
                        let allCountryToIds = this.allCountryTo.items.map(x => x.id);
                        // let cashTourTo = JSON.parse(methods.getCookieValueByName("hotelsTourTo"));

                        let cashTourTo = !this.getMainSearchCount ? JSON.parse(methods.getCookieValueByName("hotelsTourTo")) : this.searchTour.to;
                        let settingsCashTourTo = window.settings.destinationForHotels;
                        data.filter(x => !allCountryToIds.includes(x.key)).forEach((val) => {
                            this.allCountryTo.items.push({
                                text: val.Name,
                                id: val.Key,
                                isChecked: false
                            });
                            if (
                                cashTourTo && cashTourTo[0] == val.Key ||
                                settingsCashTourTo == val.Key
                            ) {
                                isCash = true;
                                this.focusFilterTourTypeReady = true;
                            }
                        });
                        if (!isCash || this.getWindowSettings.commonFiltersForHotels && !this.$route.params?.searchParams && !settingsCashTourTo) {
                            this.searchTour.to = [];
                        } else {
                            const id = this.searchTour.to.length ? this.searchTour.to[0] : typeof settingsCashTourTo === "number" ? settingsCashTourTo : cashTourTo[0];
                            this.getCitiesTo([{ id }])
                                .then((res2) => {
                                    if (!res2) return;

                                    const citiesKeys = res2.data.map(x => x.Key)
                                    let settingsDestCities = window.settings.destCitiesForHotels?.filter(x => {
                                        if (citiesKeys.includes(x)) return x;
                                    });
                                    if   (
                                        settingsDestCities?.length &&
                                        !(settingsDestCities.length === 1 && settingsDestCities[0] === -1)
                                    ) {
                                        this.searchTour.to = [ id, ...settingsDestCities ]
                                    } else if (this.searchTour.to.length) {
                                        return
                                    } else {
                                        this.searchTour.to = typeof settingsCashTourTo === "number" ? [settingsCashTourTo] : cashTourTo;
                                    }
                                })
                        }
                    });
            },
            getCitiesToWithCash(e) {
                this.getCitiesTo(e)
                    .then((res) => {
                        if (!window.settings.destCitiesForHotels || !res) return;

                        const citiesKeys = res.data.map(x => x.Key)
                        let settingsDestCities = window.settings.destCitiesForHotels.filter(x => {
                            if (citiesKeys.includes(x)) return x;
                        });
                        if   (
                            settingsDestCities?.length &&
                            !(settingsDestCities.length === 1 && settingsDestCities[0] === -1)
                        ) {
                            this.searchTour.to = [ e[0].id, ...settingsDestCities ]
                        }
                    })
            },
            getCitiesTo(country) {
                return new Promise((resolve) => {
                    let cities = this.searchTour.from.map(x => `cityKeys=${x}`);
                    const api = this.API_URL + 'ActualizeCities?' + cities.join("&") + '&Key=' + country[0].id;

                    if (api === this.countryOldApi){
                        const allCitiesTo = [...this.allCitiesTo];
                        this.allCitiesTo = [];
                        setTimeout(() => {
                            this.allCitiesTo = allCitiesTo;

                            resolve();
                        }, 0);

                        return
                    }
                    this.countryOldApi = api;

                    Vue.Api.Get(api)
                        .then(res => {
                            this.allCitiesTo = [];
                            res.data.forEach(x => {
                                this.allCitiesTo.push({
                                    text: x.Name,
                                    id: x.Key,
                                    isChecked: false
                                })
                            });
                            resolve(res)
                        });
                });
            },
            getTourType() {
                const date = new Date().getTime();
                const cities = this.searchTour.from.map(x => `departureCityKeys[]=${x}`);

                let countryTo;
                let citiesTo;
                if (this.easySearchFilterForHotels) {
                    countryTo = this.searchTour.combo.countryKey;
                    citiesTo = [`destinationCity[]=${this.searchTour.combo.cityKey}`];
                } else {
                    countryTo = this.searchTour.to[0];
                    citiesTo = this.searchTour.to.filter((x, i) => i !== 0).map(x => `destinationCity[]=${x}`);
                }

                if (!citiesTo.length || this.searchTour.combo.isResort || this.searchTour.combo.isHotel) citiesTo = ["destinationCity[]=-1"];

                if (!cities || !countryTo || !citiesTo) return;

                const sendParams = `${this.API_URL}ActualizeTourType?${cities.join("&")}&Key=${countryTo}&Type=1&${citiesTo.join("&")}&terms=&allTitle=Все&_=${date}`;
                if (sendParams === this.tourTypeOldApi) return;
                this.tourTypeOldApi = sendParams;

                return new Promise((resolve) => {
                    Vue.Api.Get(sendParams)
                        .then(res => {
                            this.tourTypeItems.items = [];
                            const isCash = JSON.parse(methods.getCookieValueByName("hotelsTourType"));

                            if (isCash && !this.getMainSearchCount) {
                                this.searchTour.tourType = isCash;
                            }

                            res.data.forEach((x, i) => {
                                if (i === 0 && !isCash && !this.searchTour.tourType.length) {
                                    this.searchTour.tourType = [x.Key];
                                }
                                this.tourTypeItems.items.push({
                                    text: x.Name,
                                    id: x.Key,
                                    isChecked: false
                                });
                                this.tourTypeItemsChange++
                            });

                            const tourTypeKeys = res.data.map(x => x.Key);
                            const tourTypeCash = window.settings.tourTypeForHotels !== undefined ? window.settings.tourTypeForHotels : []
                            let settingsTourType = tourTypeCash.filter(x => {
                                if (tourTypeKeys.includes(x)) return x;
                            });
                            if   (
                                settingsTourType?.length &&
                                !(settingsTourType.length === 1 && settingsTourType[0] === -1)
                            ) {
                                this.searchTour.tourType = settingsTourType
                            }
                            resolve()
                        })
                })
            },
            globalDateFormat(date) {
                return date.split(".").reverse().join("/")
            },
            getActiveDate() {
                if (
                    this.easySearchFilterForHotels && !this.searchTour.combo.countryKey ||
                    !this.easySearchFilterForHotels && this.searchTour.to.length < 2 && this.getSettings.IsShowFiltersByCity
                ) {
                    return
                }
                let cities = this.searchTour.from.map(x => `departureCity=${x}`);
                let citiesTo;
                let countryTo;
                if (this.easySearchFilterForHotels) {
                    citiesTo = [`destinationCity=${this.searchTour.combo.cityKey}`];
                    citiesTo = this.searchTour.combo.cityKey && !this.searchTour.combo.isResort && !this.searchTour.combo.isHotel
                        ? citiesTo : ["destinationCity=-1"];
                    countryTo = this.searchTour.combo.countryKey;
                } else {
                    citiesTo = this.searchTour.to.filter((x, i) => i !== 0).map(x => `destinationCity=${x}`);
                    citiesTo = citiesTo.length ? citiesTo : ["destinationCity=-1"];
                    countryTo = this.searchTour.to[0];
                }

                let tourTypes = this.searchTour.tourType.map(x => `tourTypes=${x}`).join("&");
                Vue.Api.Get(this.API_URL + 'TourDate?' + cities.join("&") + "&" + citiesTo.join("&") + '&Key=' + countryTo + "&Type=1" + "&" + tourTypes)
                    .then(res => {
                        this.activeDates = res.data;
                        this.date.dates = [];

                        // let cashDate = JSON.parse(methods.getCookieValueByName("hotelsTourDate"))
                        let cashDate = this.getMainSearchCount ? this.date : JSON.parse(methods.getCookieValueByName("hotelsTourDate"))
                        let helper = false;
                        let dates = [];
                        let currentDay = moment(new Date()).format("DD.MM.YYYY");
                        if (cashDate && cashDate?.dates?.length) {
                            cashDate.dates.forEach(x => {
                                if (this.activeDates.includes(x) ||
                                    (!this.activeDates.length && this.globalDateFormat(x) >= this.globalDateFormat(currentDay))) {
                                    dates.push(x);
                                    helper = true
                                }
                            })
                        }
                        if (helper) {
                            this.date = {
                                dates,
                                daysCount: {
                                    from: cashDate.daysCount.from,
                                    to: cashDate.daysCount.to
                                }
                            };
                        }
                    });
            },
            searchFirstTime() {
                this.$nextTick(() => {
                    if (this.$route.params.searchParams && this.urlSearchStatus) {
                        this.search("tour");
                        this.urlSearchStatus = false;
                    } else if (this.getWindowSettings.commonFiltersForHotels) {
                        this.commonSearch()
                        this.urlSearchStatus = false
                    }
                })
            },
            getMinMaxDays(dates) {
                if (
                    this.easySearchFilterForHotels && dates.length && this.searchTour.combo.countryKey ||
                    !this.easySearchFilterForHotels && dates.length && this.searchTour.to.length
                ) {
                    let cities = this.searchTour.from.map(x => `departureCity=${x}`);
                    let citiesTo;
                    let countryTo;
                    if (this.easySearchFilterForHotels) {
                        citiesTo = [`destinationCity=${this.searchTour.combo.cityKey}`];
                        citiesTo = this.searchTour.combo.cityKey && !this.searchTour.combo.isResort && !this.searchTour.combo.isHotel
                            ? citiesTo : ["destinationCity=-1"];
                        countryTo = this.searchTour.combo.countryKey
                    } else {
                        citiesTo = this.searchTour.to.filter((x, i) => i !== 0).map(x => `destinationCity=${x}`);
                        countryTo = this.searchTour.to[0]
                    }

                    let date = dates.map(x => `tourDate=${x}`);
                    let tourTypes = this.searchTour.tourType.map(x => `tourTypes=${x}`).join("&");
                    const api = this.API_URL + 'Duration?' +
                        cities.join("&") + "&" +
                        (citiesTo.length ? citiesTo.join("&") : "destinationCity=-1") +
                        '&Key=' + countryTo +
                        `&Type=1&${tourTypes}` + "&" + date.join("&");

                    if (this.durationOldApi === api) {
                        this.daysCount = methods.fullCopy(this.daysCountCash);
                        return
                    }
                    this.durationOldApi = api;

                    Vue.Api.Get(api)
                        .then(res => {
                            this.daysCount = res.data.map(x => {
                                return {
                                    value: x,
                                    label: x
                                }
                            });
                            this.daysCountCash = methods.fullCopy(this.daysCount)
                        });
                }
            },
            commonSearch() {
                if (this.easySearchFilterForHotels) return;

                if (this.searchLoaderStatus) return;

                this.mainSearchStatus = false;

                if (!this.searchTour.from.length) return;

                if (this.searchTour.to.length < 1) return;

                if (this.searchTour.to.length < 2 && this.getSettings.IsShowFiltersByCity) return;

                if (!this.searchTour.tourType.length) return;

                if (!Object.entries(this.date).length) return;

                if (!this.date.dates.length) return;

                // this.searchLoaderStatus = true;

                this.$store.commit("hotels/" + mTypesHotels.M_SET_SEARCH_LOADER_STATUS, true)
                bus.$emit("price-loader-hotels", true),
                bus.$emit("hotels-start-search");

                let aviaDefault = this.settings.DefaultAirFilter;
                let hotelDefault = this.settings.DefaultHotelFilter;
                let busDefault = this.settings.DefaultBusFilter;
                let railwayDefault = this.settings.DefaultRailwayFilter;
                let cities = this.searchTour.from;
                let citiesTo;
                let countryTo;
                let hotel;
                let resort;
                let city;
                if (this.easySearchFilterForHotels) {
                    citiesTo = this.searchTour.combo.isCity ? [this.searchTour.combo.cityKey] : [];
                    countryTo = this.searchTour.combo.countryKey;
                    hotel = this.searchTour.combo.isHotel ? this.searchTour.combo.hotelKey : null;
                    resort = this.searchTour.combo.isResort ? this.searchTour.combo.resortKey : null;
                    city = this.searchTour.combo.isCity ? this.searchTour.combo.cityKey : null;
                } else {
                    citiesTo = this.searchTour.to.filter((x, i) => i !== 0);
                    countryTo = this.searchTour.to[0];
                }
                let date = Array.from(new Set(this.date.dates));
                let adultCount = this.tourPeople.adult.count;
                let children = this.tourPeople.children.slice();
                let days = [];
                const daysFrom = (this.getSettings.TourSearchMode === 1 || this.getSettings.TourSearchMode === 2) ? this.date.daysCount.from + 1 : this.date.daysCount.from;
                const daysTo = (this.getSettings.TourSearchMode === 1 || this.getSettings.TourSearchMode === 2) ? this.date.daysCount.to + 1 : this.date.daysCount.to;
                for (let i = daysFrom; i <= daysTo; i++) {
                    days.push(i)
                }

                let page = this.pagination.page;
                let perPage = this.pagination.perPage;
                let current = new Date().getTime();
                let tourType = this.searchTour.tourType;
                let sendParam = {
                    cities,
                    citiesTo,
                    date,
                    children,
                    adultCount,
                    countryTo,
                    days,
                    tourType,
                    page,
                    perPage,
                    current,
                    hotel,
                    resort,
                    city,
                    easySearchFilters: this.easySearchFilterForHotels,
                    aviaDefault,
                    hotelDefault,
                    busDefault,
                    railwayDefault
                };

                this.$store.dispatch("hotels/A_TOUR_SEARCH_FOR_COMMON_FILTERS", sendParam)
                    .then(res => {
                        let newUrl = "/Individuals/Hotels/" + res.result;

                        bus.$emit("searched-client-hotels", true);

                        // bus.$emit("getMaxPrice-hotels");//запускаем обновление данных в фильтре "Диапазон цен"
                        let tableParam = "";
                        let paramsAfterCurrency = false;
                        if (this.$route.params.searchParams) {
                            this.$route.params.searchParams.split("&").forEach(x => {
                                // if (this.easySearchFilterForHotels && x.match(/resorts|hotels|cities/)) {
                                //     return;
                                // }
                                if (paramsAfterCurrency) {
                                    tableParam += "&" + x
                                }
                                if (x.includes("currency=")) {
                                    paramsAfterCurrency = true
                                }
                            });
                        }

                        newUrl = tableParam.length && !newUrl.includes(tableParam) ? newUrl + tableParam : newUrl;

                        if (this.$route.fullPath !== newUrl) {
                            this.$nextTick(() => {
                                if (!this.$route.path.includes(newUrl)) {
                                    this.$router.push(newUrl);
                                }
                                this.$nextTick(() => this.mainSearchStatus = true);
                            });
                        } else {
                            this.$nextTick(() => this.mainSearchStatus = true)
                        }
                        bus.$emit("price-loader-hotels", false)
                        this.$store.commit("hotels/" + mTypesHotels.M_SET_SEARCH_LOADER_STATUS, false)
                        this.$store.commit("hotels/" + mTypesHotels.M_SET_URL_SET_STATUS, false)
                        bus.$emit('searched-for-hotels', res.outSistem)
                        // Флаг для однократного вызова функции (при перезагрузке)
                        this.$store.commit("hotels/" + mTypesHotels.M_SET_ON_MOUNTED_CHANGE_DAYS_FLAG, true)
                    })
                    .catch((err) => {
                        // this.searchLoaderStatus = false;
                        this.$store.commit("hotels/" + mTypesHotels.M_SET_SEARCH_LOADER_STATUS, false)
                        console.log(err);
                    });
            },
            search(type, clientClick = false) {
                if (this.searchLoaderStatus) {
                    return
                }
                this.mainSearchStatus = false;

                if (type === "tour") {
                    if (!this.searchTour.from.length) {
                        let text = `${this.localizeList.firstSetField} ${this.localizeList.fromUpper}`
                        this.showValidation(text)
                        return
                    }
                    if (
                        this.easySearchFilterForHotels && !this.searchTour.combo.countryKey ||
                        !this.easySearchFilterForHotels && this.searchTour.to.length < 1
                    ) {
                        let text = `${this.localizeList.firstSetField} ${this.localizeList.departTo}`;
                        this.showValidation(text);
                        return;
                    }
                    if (!this.easySearchFilterForHotels && this.searchTour.to.length < 2 && this.getSettings.IsShowFiltersByCity) {
                        let text = `${this.localizeList.firstSetField} ${this.localizeList.cityUpper}`;
                        this.showValidation(text);
                        return;
                    }
                    if (!this.searchTour.tourType.length) {
                        let text = `${this.localizeList.firstSetField} ${this.localizeList.tourType}`
                        this.showValidation(text)
                        return
                    }
                    if (!Object.entries(this.date).length) {
                        let text = `${this.localizeList.firstSetField} ${this.localizeList.whenUpper}`
                        this.showValidation(text);
                        return
                    }
                    if (!this.date.dates.length) {
                        let text = `${this.localizeList.firstSetField} ${this.localizeList.whenUpper}`
                        this.showValidation(text)
                        return
                    }
                    let invalidAge = this.tourPeople.children.find(x => x.age === null)
                    if (invalidAge) {
                        let text = this.localizeList.setChildAge;
                        this.showValidation(text);
                        return
                    }
                }

                if (this.getWindowSettings.commonFiltersForHotels) {
                  bus.$emit("page-load", true)
                } else {
                  bus.$emit("price-loader-hotels", true)
                }

                this.$store.commit("hotels/" + mTypesHotels.M_SET_SEARCH_LOADER_STATUS, true)
                bus.$emit("hotels-start-search");
                let aviaDefault = this.settings.DefaultAirFilter;
                let hotelDefault = this.settings.DefaultHotelFilter;
                let busDefault = this.settings.DefaultBusFilter;
                let railwayDefault = this.settings.DefaultRailwayFilter;
                let cities = this.searchTour.from;
                let citiesTo;
                let countryTo;
                let hotel;
                let resort;
                let city;
                let cityKeysOfResorts;
                if (this.easySearchFilterForHotels) {
                    citiesTo = this.searchTour.combo.isCity ? [this.searchTour.combo.cityKey] : [];
                    cityKeysOfResorts = this.searchTour.combo.cityKeysOfResorts;
                    countryTo = this.searchTour.combo.countryKey;
                    hotel = this.searchTour.combo.isHotel ? this.searchTour.combo.hotelKey : null;
                    resort = this.searchTour.combo.isResort ? this.searchTour.combo.resortKey : null;
                    city = this.searchTour.combo.isCity ? this.searchTour.combo.cityKey : null;
                } else {
                    citiesTo = this.searchTour.to.filter((x, i) => i !== 0);
                    countryTo = this.searchTour.to[0];
                }
                let date = Array.from(new Set(this.date.dates));
                let adultCount = this.tourPeople.adult.count;
                let children = this.tourPeople.children.slice();
                let days = [];
                const daysFrom = (this.getSettings.TourSearchMode === 1 || this.getSettings.TourSearchMode === 2) ? this.date.daysCount.from + 1 : this.date.daysCount.from;
                const daysTo = (this.getSettings.TourSearchMode === 1 || this.getSettings.TourSearchMode === 2) ? this.date.daysCount.to + 1 : this.date.daysCount.to;
                for (let i = daysFrom; i <= daysTo; i++) {
                    days.push(i)
                }

                let page = this.pagination.page;
                let perPage = this.pagination.perPage;
                let current = new Date().getTime();
                let tourType = this.searchTour.tourType;

                let hotelsFromUrl = this.$route.params.searchParams?.split("&")?.find(x => x.includes("hotels")) || [];
                if (hotelsFromUrl.length) hotelsFromUrl = hotelsFromUrl.split("=")[1].split(",");

                let sendParam = {
                    cities,
                    citiesTo,
                    cityKeysOfResorts,
                    date,
                    children,
                    adultCount,
                    countryTo,
                    days,
                    tourType,
                    page,
                    perPage,
                    current,
                    hotel,
                    resort,
                    city,
                    easySearchFilters: this.easySearchFilterForHotels,
                    aviaDefault,
                    hotelDefault,
                    busDefault,
                    railwayDefault,
                    hotelsFromUrl
                };

                this.$store.dispatch("hotels/A_TOUR_SEARCH", sendParam)
                    .then(res => {
                        let newUrl = "/Individuals/Hotels/" + res.result;

                        if (res.outSistem) {
                            bus.$emit("hotels-has-out-sistem", true);

                            bus.$emit("hotels-out-sistem-load", true);
                            this.$store.dispatch("hotels/A_SEARCH_OUT_HOTEL", sendParam)
                                .then(() => {
                                    bus.$emit("out-sistem-searched-hotels");
                                    bus.$emit("hotels-out-sistem-load", false);
                                })
                                .catch( () => {
                                    bus.$emit("out-sistem-searched-hotels");
                                    bus.$emit("hotels-out-sistem-load", false);
                                })
                        }

                        if (clientClick) {
                            bus.$emit("searched-client-hotels", true);
                        }

                        let tableParam = "";
                        let paramsAfterCurrency = false;
                        if (this.$route.params.searchParams) {
                            this.$route.params.searchParams.split("&").forEach(x => {
                                // if (this.easySearchFilterForHotels && x.match(/resorts|hotels|cities/)) {
                                //     return;
                                // }
                                if (paramsAfterCurrency) {
                                    tableParam += "&" + x
                                }
                                if (x.includes("currency=")) {
                                    paramsAfterCurrency = true
                                }
                            });
                        }

                        newUrl = tableParam.length && !newUrl.includes(tableParam) ? newUrl + tableParam : newUrl;
                        if (this.$route.fullPath !== newUrl) {
                            this.$nextTick(() => {
                                if (!this.$route.path.includes(newUrl)) {
                                    this.$router.push(newUrl);
                                }
                                this.$nextTick(() => this.mainSearchStatus = true);
                            });
                        } else {
                            this.$nextTick(() => this.mainSearchStatus = true)
                        }

                        this.$store.commit("hotels/" + mTypesHotels.M_SET_SEARCH_LOADER_STATUS, false)
                        this.$store.commit("hotels/" + mTypesHotels.M_SET_URL_SET_STATUS, false)
                        bus.$emit('searched-for-hotels', res.outSistem)

                        if (this.getWindowSettings.commonFiltersForHotels && !this.getCheckFilterSelect) {
                           bus.$emit("page-load", false);
                        } else {
                           bus.$emit("price-loader-hotels", false)
                        }

                        // Флаг для однократного вызова функции (при перезагрузке)
                        this.$store.commit("hotels/" + mTypesHotels.M_SET_ON_MOUNTED_CHANGE_DAYS_FLAG, true)
                    })
                    .catch((err) => {
                        // this.searchLoaderStatus = false;
                        this.$store.commit("hotels/" + mTypesHotels.M_SET_SEARCH_LOADER_STATUS, false)
                        if (this.getWindowSettings.commonFiltersForHotels && !this.getCheckFilterSelect) {
                           bus.$emit("page-load", false);
                        } else {
                           bus.$emit("price-loader-hotels", false)
                        }
                        console.log(err);
                    });

                const settings = this.$store.getters['getSettings'];
                const showPriceTable = window.settings.priceTableOpenForHotels !== undefined ? window.settings.priceTableOpenForHotels : settings.ShowPriceTableInSearch;
                const listTypeDefault = window.settings.additionalFilterOpenForHotels !== undefined ? window.settings.additionalFilterOpenForHotels : settings.ExtraFilterToShowInSearch;
                if (showPriceTable && listTypeDefault === 1 && !this.getWindowSettings.commonFiltersForHotels) {
                    this.$store.dispatch('hotels/A_GET_PRICE_TABLE')
                }
            },
            searchTourTo(val) {
                document.cookie = `hotelsTourFrom=${JSON.stringify(val)}; path=/`;

                if (val?.length) {
                    this.getCountryTo("tour");
                } else if (this.easySearchFilterForHotels) {
                    this.searchTour.combo = {}
                }

                if (this.date && this.date.dates) {
                    this.getMinMaxDays(this.date.dates)
                }

                if (
                    val.length &&
                    (
                        this.easySearchFilterForHotels && this.searchTour.combo.countryKey ||
                        !this.easySearchFilterForHotels && this.searchTour.to.length > 1 ||
                        !this.easySearchFilterForHotels && !this.getSettings.IsShowFiltersByCity && this.searchTour.to.length === 1
                    )
                ) {
                    this.getTourType();
                }
            },
        },
        beforeDestroy() {
            window.removeEventListener('keydown', this.keyDown);
            window.removeEventListener("scroll", this.scroll);
        },
        watch: {
            activeDates: {
                deep: true,
                handler(val, oldVal) {
                    if (JSON.stringify(val) === JSON.stringify(oldVal)) {
                        return
                    }
                    const minDate = new Date().getTime();
                    this.activeDates = val.filter(x => {
                        const date = x.split(".").reverse();
                        return new Date(...date).getTime() > minDate
                    });
                }
            },
            'searchFlights.from'() {
                if (this.date.dates) {
                    this.getMinMaxDays(this.date.dates)
                }
            },
            'searchTour.combo'(val) {
                let hotelsTourToCombo = encodeURIComponent(JSON.stringify(val));
                document.cookie = `hotelsTourToCombo=${hotelsTourToCombo}; path=/`;
                if (val.countryKey)
                    this.getTourType();
                else
                    this.searchTour.tourType = []
            },
            'searchTour.to'(val, oldVal) {
                let isRepeat = methods.checkEquality(val, oldVal);
                if (val[0] !== oldVal[0] && this.getWindowSettings.commonFiltersForHotels) {
                  this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false)
                  if (this.getSearchSecondParamsCounter > 0) bus.$emit("clearAllFilters-hotels", true, true);
                }
                document.cookie = `hotelsTourTo=${JSON.stringify(val)}; path=/`;
                if (
                    !isRepeat &&
                    (
                        val.length > 1 ||
                        !this.getSettings.IsShowFiltersByCity && val.length === 1
                    )
                ) {
                    this.changeSearchTourTo = true;
                    this.getTourType();
                }
            },
            'searchTour.tourType'(val, oldVal) {
                const isRepeat = methods.checkEquality(val, oldVal);
                if (!isRepeat || this.changeSearchTourTo) {
                    this.getActiveDate();
                    this.changeSearchTourTo = false;
                }

                if (isRepeat) return;

                if (JSON.stringify(val) === JSON.stringify(oldVal))
                    return;

                if (!val.length) {
                    this.focusFilterTourTypeReady = false;
                }

                document.cookie = `hotelsTourType=${JSON.stringify(val)}; path=/`;
            },
            date: {
                deep: true,
                handler(val, oldVal) {
                // Скрываем результаты поиска если дата была изменена
                const isRepeat = methods.checkEquality(val, oldVal);
                if (!isRepeat && this.getWindowSettings.commonFiltersForHotels) {
                  this.$store.commit("hotels/" + mTypesHotels.M_SET_SHOW_TOUR_RESULT_LIST, false)
                }
                }
            },
            tourPeople: {
                deep: true,
                handler(val) {
                    document.cookie = `hotelsTourPeople=${JSON.stringify(val)}; path=/`;
                }
            }
        }
    }
</script>

<style scoped>
    #main-filters.common-filters-navbar-mode {
        background-color: var(--white-color);
    }

    .fixed {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
    }
    
    .tour-navbar-sup {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 4px 60px 0;
        background-color: var(--primary-color);
    }
    
    .change-device-btn {
        cursor: pointer;
        padding: 3px 16px;
        color: white;
        background: transparent;
        border: none;
        text-decoration: underline;
    }

    .tour-navbar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 60px 0;
        background-color: var(--primary-color);
    }

    .tour-navbar .tour-type-controller {
        display: flex;
    }

    .tour-navbar /deep/ .direct-btn.radio-btn {
        grid-gap: 4px;
        font-size: 12px;
        font-weight: 600;
        color: var(--white-color);
    }

    .tour-navbar /deep/ .c-checkbox #c-checkbox {
        font-weight: 600;
    }

    .tour-navbar .tour-type-controller .tour-type {
        min-width: 140px;
        padding: 0 20px;
        min-height: 30px;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(255, 255, 255, .3);
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        color: var(--white-color);
        cursor: pointer;
    }

    .tour-navbar .tour-type-controller .tour-type:not(:last-child) {
        margin-right: 4px;
    }

    .tour-navbar .tour-type-controller .tour-type.active {
        background-color: var(--white-color);
        color: var(--dark-2-color);
    }

    .tour-navbar .project-controller {
        display: flex;
        align-items: center;
    }

    .tour-navbar .project-controller .project-controller-item {
        padding: 5px 16px;
        position: relative;
        font-weight: 500;
        font-size: 13px;
        line-height: 15px;
        text-decoration: none;
        color: var(--white-color);
    }

    .tour-navbar .project-controller .project-controller-swich {
        margin-right: 16px;
    }

    .tour-navbar .project-controller .project-controller-item:nth-child(2):before {
        content: "";
        width: 1px;
        height: 60%;
        background-color: var(--white-color);
        position: absolute;
        top: 20%;
        left: 0;
    }

    .tour-navbar .project-controller .project-controller-item:not(:last-child):after {
        content: "";
        width: 1px;
        height: 60%;
        background-color: var(--white-color);
        position: absolute;
        top: 20%;
        right: 0;
    }

    .search-bar {
        padding: 10px 60px;
        background-color: var(--white-color);
        display: grid;
        grid-template-columns: repeat(2, 1fr) auto 1fr auto;
        grid-gap: 4px;
    }

    .search-bar.tour-from-hide,
    .search-bar.tour-type-hide {
        /* grid-template-columns: repeat(4, 1fr) auto; */
        grid-template-columns: repeat(2, 1fr) auto 1fr auto;
    }

    .search-bar.tour-type-and-tour-from-hide {
        grid-template-columns: 1fr auto 1fr auto !important;
    }

    .search-bar.tour-from-hide.tour-easy-search-mode,
    .search-bar.tour-type-hide.tour-easy-search-mode {
        /* grid-template-columns: 2fr repeat(3, 1fr) auto; */
        grid-template-columns: 2fr 1fr auto 1fr auto; /* Для реализации раздельной даты и проллжительности */
    }

    .search-bar.common-filters-search-mode {
        grid-template-columns: repeat(2, 1fr) auto 1fr;
        max-width: 1320px;
        margin: 0 auto;
    }

    .search-bar.tour-from-hide.tour-type-hide {
        /*grid-template-columns: repeat(3, 1fr) auto;*/
        grid-template-columns: 2fr 1fr 1fr auto;
    }

    a.focus {
        outline: #000 auto 1px;
    }

    .search-btn-helper {
        position: absolute;
        opacity: 0;
        z-index: -1;
    }

    .switch-version-btn {
        background: transparent;
        border: none;
    }
</style>
